import{defineMessages as t}from"react-intl";const a=t({contactCardHeader:{id:"press.contactCard.header.text",defaultMessage:"Press contact"},contactCardButton:{id:"press.contactCard.button.text",defaultMessage:"Download Press Kit"}});export{a as default};
//# sourceMappingURL=messages.js.map
